import React from 'react';
import PropTypes from 'prop-types';

const RadioGift = ({ enabledGiftCard, onChangeEnabledGiftCard }) => {
  return (
    <div className="radio RadioCash">
      <div className="radioItem" onClick={() => onChangeEnabledGiftCard(false)}>
        <input type="radio" name="radio-gift-1" className="radio-input" id="cashGift-1" checked={!enabledGiftCard} readOnly />
        <label htmlFor="cashGift-1">利用しない</label>
      </div>
      <div className="radioItem" onClick={() => onChangeEnabledGiftCard(true)}>
        <input type="radio" name="radio-gift-2" className="radio-input" id="cashGift-2" checked={enabledGiftCard} readOnly />
        <label htmlFor="cashGift-2">利用する</label>
      </div>
    </div>
  );
};

RadioGift.propTypes = {
  onChangeEnabledGiftCard: PropTypes.func.isRequired,
  enabledGiftCard: PropTypes.bool.isRequired,
};

export default RadioGift;
